import React from 'react';
import AdComponent from './AdComponent';

// Specific ad placement components for different sections

export const HomepageAd = ({ className = "" }) => (
  <AdComponent
    placement="homepage"
    className={className}
    onAdLoad={(data) => console.log('Homepage ad loaded:', data.campaign_id)}
    onAdClick={(data) => console.log('Homepage ad clicked:', data.title)}
  />
);

export const ProfileCreationAd = ({ className = "" }) => (
  <AdComponent
    placement="profile_creation"
    className={className}
    onAdLoad={(data) => console.log('Profile creation ad loaded:', data.campaign_id)}
    onAdClick={(data) => console.log('Profile creation ad clicked:', data.title)}
  />
);

export const SpeedDatingBreakAd = ({ className = "", onClose = null }) => (
  <AdComponent
    placement="speed_dating_break"
    className={className}
    onAdLoad={(data) => console.log('Speed dating break ad loaded:', data.campaign_id)}
    onAdClick={(data) => {
      console.log('Speed dating break ad clicked:', data.title);
      if (onClose) onClose();
    }}
  />
);

export const IcebreakersAd = ({ className = "" }) => (
  <AdComponent
    placement="icebreakers"
    className={className}
    onAdLoad={(data) => console.log('Icebreakers ad loaded:', data.campaign_id)}
    onAdClick={(data) => console.log('Icebreakers ad clicked:', data.title)}
  />
);

export const MatchResultsAd = ({ className = "" }) => (
  <AdComponent
    placement="match_results"
    className={className}
    onAdLoad={(data) => console.log('Match results ad loaded:', data.campaign_id)}
    onAdClick={(data) => console.log('Match results ad clicked:', data.title)}
  />
);

export const DateRecommendationsAd = ({ className = "" }) => (
  <AdComponent
    placement="date_recommendations"
    className={className}
    onAdLoad={(data) => console.log('Date recommendations ad loaded:', data.campaign_id)}
    onAdClick={(data) => console.log('Date recommendations ad clicked:', data.title)}
  />
);